import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import V, { popoverBodyProps as $ } from "./PopoverBody.js";
import L from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/life-cycle/use-is-mounted.js";
import K from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-merged-state.js";
import A from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-memo.js";
import q from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-compitable.js";
import { getFirstSlotVNode as G } from "../../_utils/vue/get-first-slot-vnode.js";
import { defineComponent as J, watchEffect as F, computed as O, provide as Q, cloneVNode as X, Text as Y, h as w, withDirectives as Z } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import ee from "../../../../../../vdirs@0.1.8_vue@3.5.18/node_modules/vdirs/es/zindexable/index.js";
import ne from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/binder/src/Target.js";
import { keep as te } from "../../_utils/vue/keep.js";
import oe from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/binder/src/Binder.js";
import re from "../../_mixins/use-theme.js";
import { warnOnce as v } from "../../_utils/naive/warn.js";
import { call as b } from "../../_utils/vue/call.js";
import { ref as B, toRef as T } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { useAdjustedTo as ie } from "../../_utils/composable/use-adjusted-to.js";
const ae = Object.keys($), le = {
  focus: ["onFocus", "onBlur"],
  click: ["onClick"],
  hover: ["onMouseenter", "onMouseleave"],
  manual: [],
  nested: ["onFocus", "onBlur", "onMouseenter", "onMouseleave", "onClick"]
};
function se(e, h, p) {
  le[h].forEach((t) => {
    e.props ? e.props = Object.assign({}, e.props) : e.props = {};
    const d = e.props[t], i = p[t];
    d ? e.props[t] = (...r) => {
      d(...r), i(...r);
    } : e.props[t] = i;
  });
}
const de = {
  show: {
    type: Boolean,
    default: void 0
  },
  defaultShow: Boolean,
  showArrow: {
    type: Boolean,
    default: !0
  },
  trigger: {
    type: String,
    default: "hover"
  },
  delay: {
    type: Number,
    default: 100
  },
  duration: {
    type: Number,
    default: 100
  },
  raw: Boolean,
  placement: {
    type: String,
    default: "top"
  },
  x: Number,
  y: Number,
  arrowPointToCenter: Boolean,
  disabled: Boolean,
  getDisabled: Function,
  displayDirective: {
    type: String,
    default: "if"
  },
  arrowClass: String,
  arrowStyle: [String, Object],
  arrowWrapperClass: String,
  arrowWrapperStyle: [String, Object],
  flip: {
    type: Boolean,
    default: !0
  },
  animated: {
    type: Boolean,
    default: !0
  },
  width: {
    type: [Number, String],
    default: void 0
  },
  overlap: Boolean,
  keepAliveOnHover: {
    type: Boolean,
    default: !0
  },
  zIndex: Number,
  to: ie.propTo,
  scrollable: Boolean,
  contentClass: String,
  contentStyle: [Object, String],
  headerClass: String,
  headerStyle: [Object, String],
  footerClass: String,
  footerStyle: [Object, String],
  // events
  onClickoutside: Function,
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  // internal
  internalDeactivateImmediately: Boolean,
  internalSyncTargetWithParent: Boolean,
  internalInheritedEventHandlers: {
    type: Array,
    default: () => []
  },
  internalTrapFocus: Boolean,
  internalExtraClass: {
    type: Array,
    default: () => []
  },
  // deprecated
  onShow: [Function, Array],
  onHide: [Function, Array],
  arrow: {
    type: Boolean,
    default: void 0
  },
  minWidth: Number,
  maxWidth: Number
}, ue = Object.assign(Object.assign(Object.assign({}, re.props), de), {
  internalOnAfterLeave: Function,
  internalRenderBody: Function
}), ke = J({
  name: "Popover",
  inheritAttrs: !1,
  props: ue,
  slots: Object,
  __popover__: !0,
  setup(e) {
    process.env.NODE_ENV !== "production" && F(() => {
      e.maxWidth !== void 0 && v("popover", "`max-width` is deprecated, please use `style` instead."), e.minWidth !== void 0 && v("popover", "`min-width` is deprecated, please use `style` instead."), e.arrow !== void 0 && v("popover", "`arrow` is deprecated, please use `showArrow` instead."), e.onHide !== void 0 && v("popover", "`on-hide` is deprecated, please use `on-update:show` instead."), e.onShow !== void 0 && v("popover", "`on-show` is deprecated, please use `on-update:show` instead.");
    });
    const h = L(), p = B(null), t = O(() => e.show), d = B(e.defaultShow), i = K(t, d), r = A(() => e.disabled ? !1 : i.value), o = () => {
      if (e.disabled)
        return !0;
      const {
        getDisabled: n
      } = e;
      return !!(n != null && n());
    }, u = () => o() ? !1 : i.value, l = q(e, ["arrow", "showArrow"]), s = O(() => e.overlap ? !1 : l.value);
    let C = null;
    const m = B(null), g = B(null), E = A(() => e.x !== void 0 && e.y !== void 0);
    function c(n) {
      const {
        "onUpdate:show": a,
        onUpdateShow: f,
        onShow: R,
        onHide: k
      } = e;
      d.value = n, a && b(a, n), f && b(f, n), n && R && b(R, !0), n && k && b(k, !1);
    }
    function P() {
      C && C.syncPosition();
    }
    function y() {
      const {
        value: n
      } = m;
      n && (window.clearTimeout(n), m.value = null);
    }
    function S() {
      const {
        value: n
      } = g;
      n && (window.clearTimeout(n), g.value = null);
    }
    function _() {
      const n = o();
      if (e.trigger === "focus" && !n) {
        if (u())
          return;
        c(!0);
      }
    }
    function x() {
      const n = o();
      if (e.trigger === "focus" && !n) {
        if (!u())
          return;
        c(!1);
      }
    }
    function I() {
      const n = o();
      if (e.trigger === "hover" && !n) {
        if (S(), m.value !== null || u())
          return;
        const a = () => {
          c(!0), m.value = null;
        }, {
          delay: f
        } = e;
        f === 0 ? a() : m.value = window.setTimeout(a, f);
      }
    }
    function M() {
      const n = o();
      if (e.trigger === "hover" && !n) {
        if (y(), g.value !== null || !u())
          return;
        const a = () => {
          c(!1), g.value = null;
        }, {
          duration: f
        } = e;
        f === 0 ? a() : g.value = window.setTimeout(a, f);
      }
    }
    function D() {
      M();
    }
    function H(n) {
      var a;
      u() && (e.trigger === "click" && (y(), S(), c(!1)), (a = e.onClickoutside) === null || a === void 0 || a.call(e, n));
    }
    function j() {
      if (e.trigger === "click" && !o()) {
        y(), S();
        const n = !u();
        c(n);
      }
    }
    function W(n) {
      e.internalTrapFocus && n.key === "Escape" && (y(), S(), c(!1));
    }
    function N(n) {
      d.value = n;
    }
    function z() {
      var n;
      return (n = p.value) === null || n === void 0 ? void 0 : n.targetRef;
    }
    function U(n) {
      C = n;
    }
    return Q("NPopover", {
      getTriggerElement: z,
      handleKeydown: W,
      handleMouseEnter: I,
      handleMouseLeave: M,
      handleClickOutside: H,
      handleMouseMoveOutside: D,
      setBodyInstance: U,
      positionManuallyRef: E,
      isMountedRef: h,
      zIndexRef: T(e, "zIndex"),
      extraClassRef: T(e, "internalExtraClass"),
      internalRenderBodyRef: T(e, "internalRenderBody")
    }), F(() => {
      i.value && o() && c(!1);
    }), {
      binderInstRef: p,
      positionManually: E,
      mergedShowConsideringDisabledProp: r,
      // if to show popover body
      uncontrolledShow: d,
      mergedShowArrow: s,
      getMergedShow: u,
      setShow: N,
      handleClick: j,
      handleMouseEnter: I,
      handleMouseLeave: M,
      handleFocus: _,
      handleBlur: x,
      syncPosition: P
    };
  },
  render() {
    var e;
    const {
      positionManually: h,
      $slots: p
    } = this;
    let t, d = !1;
    if (!h && (t = G(p, "trigger"), t)) {
      t = X(t), t = t.type === Y ? w("span", [t]) : t;
      const i = {
        onClick: this.handleClick,
        onMouseenter: this.handleMouseEnter,
        onMouseleave: this.handleMouseLeave,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      };
      if (!((e = t.type) === null || e === void 0) && e.__popover__)
        d = !0, t.props || (t.props = {
          internalSyncTargetWithParent: !0,
          internalInheritedEventHandlers: []
        }), t.props.internalSyncTargetWithParent = !0, t.props.internalInheritedEventHandlers ? t.props.internalInheritedEventHandlers = [i, ...t.props.internalInheritedEventHandlers] : t.props.internalInheritedEventHandlers = [i];
      else {
        const {
          internalInheritedEventHandlers: r
        } = this, o = [i, ...r], u = {
          onBlur: (l) => {
            o.forEach((s) => {
              s.onBlur(l);
            });
          },
          onFocus: (l) => {
            o.forEach((s) => {
              s.onFocus(l);
            });
          },
          onClick: (l) => {
            o.forEach((s) => {
              s.onClick(l);
            });
          },
          onMouseenter: (l) => {
            o.forEach((s) => {
              s.onMouseenter(l);
            });
          },
          onMouseleave: (l) => {
            o.forEach((s) => {
              s.onMouseleave(l);
            });
          }
        };
        se(t, r ? "nested" : h ? "manual" : this.trigger, u);
      }
    }
    return w(oe, {
      ref: "binderInstRef",
      syncTarget: !d,
      syncTargetWithParent: this.internalSyncTargetWithParent
    }, {
      default: () => {
        this.mergedShowConsideringDisabledProp;
        const i = this.getMergedShow();
        return [this.internalTrapFocus && i ? Z(w("div", {
          style: {
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }), [[ee, {
          enabled: i,
          zIndex: this.zIndex
        }]]) : null, h ? null : w(ne, null, {
          default: () => t
        }), w(V, te(this.$props, ae, Object.assign(Object.assign({}, this.$attrs), {
          showArrow: this.mergedShowArrow,
          show: i
        })), {
          default: () => {
            var r, o;
            return (o = (r = this.$slots).default) === null || o === void 0 ? void 0 : o.call(r);
          },
          header: () => {
            var r, o;
            return (o = (r = this.$slots).header) === null || o === void 0 ? void 0 : o.call(r);
          },
          footer: () => {
            var r, o;
            return (o = (r = this.$slots).footer) === null || o === void 0 ? void 0 : o.call(r);
          }
        })];
      }
    });
  }
});
export {
  ke as default,
  de as popoverBaseProps,
  ue as popoverProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/popover/src/Popover.js
// module id = 256
// module chunks = 41